 import { Input } from '../../Components/UI/Input/Input';
 import { CheckBox } from '../../Components/UI/Input/CheckBox';
import classes from './Auth.module.css'
import { MouseEvent, useState } from 'react';
import Button1 from '../../Components/UI/Button1/Button1';
import Select from '../../Components/UI/Select/Select';
import { log } from 'console';
import { data, Link, useNavigate } from 'react-router-dom';
import RegAPI from '../../API/RegAPI';
import FullSpaseLoader from '../../Components/UI/Loader/FullSpaseLoader';
import { IAuthForm, IAuthFormError } from '../../Intarfaces/IAuth';
import AuthAPI from '../../API/AuthAPI';
import { useDispatch } from 'react-redux';
import { getUser, setIsAuth, setStep, setUser } from '../../Store/userSlice';
import { IUser } from '../../Intarfaces/IUser';
import UserApi from '../../API/UserAPI';
 

const minData = new Date(new Date(new Date().setFullYear(new Date().getFullYear()-35)).toISOString().split("T")[0]+"T00:00:00")
const maxData = new Date(new Date(new Date().setFullYear(new Date().getFullYear()-18)).toISOString().split("T")[0]+"T00:00:00") 
const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const regexPhone = /^(\+7|8)[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/;

 const Auth = () => {

    const dispatch = useDispatch()
    const [form, setForm]  = useState({
        email:'',
        password:''
    } as IAuthForm)
    const [formError, setFormError] = useState({
    } as IAuthFormError) 

    const [isSendFormLoader, setIsSendFormLoader] = useState(false)

    const setValue = (properte:string, value:string) =>{
        setForm({...form,[properte]:value})
    }

    const nav = useNavigate()

    const validate = (formV:IAuthForm):IAuthFormError =>{
          
        const formErrorV = {} as IAuthFormError
        formErrorV.countError = 0
        for(let keyI in formV){
            
            switch (keyI){
                
                case "email":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.email = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(!regexEmail.test(formV[keyI])){
                        formErrorV.email = "Некоректный E-mail"
                        formErrorV.countError++
                    }
                    break;
                case "password":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.password = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
            }

        }
        

        return formErrorV

    }

    const sendForm = async (e:MouseEvent<HTMLButtonElement>) =>{
        e.preventDefault()
        const error = validate(form)
        setFormError(error)

        if(error.countError!==0){
            return;
        }

        setIsSendFormLoader(true)
        const response = await AuthAPI.auth(form)
        setIsSendFormLoader(false)

        setFormError({...formError, globalError:null})

        if(response.status!==200){
            setFormError({...formError, globalError: response.message})
            return;
        }

        setIsSendFormLoader(true)
        const user = await UserApi.get()
        setIsSendFormLoader(false)

        if(response.status!==200  || user?.user===null  || user?.lesson_id===null){
            setFormError({...formError, globalError: response.message})
            return;
        }

        dispatch(setUser(user.user))
        dispatch(setStep(user.lesson_id))
        dispatch(setIsAuth(true))
        nav('/education')
        
    }

    return ( 
        <div className={classes.reg}>
            <div className={classes.container}>
                <div className={classes.formName}>
                    Войти в аккаунт
                </div>
                <form>
                    <div className={classes.inputs}>
                        
                        <div className={classes.input}>
                            <Input type='email' placeholder='E-mail' value={form.email} onChange={(e)=>setValue('email', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.email}
                            </div>
                        </div>
                        
                        <div className={classes.input}>
                            <Input placeholder='Пароль' type='password' value={form.password} onChange={(e)=>setValue('password', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.password}
                            </div>
                        </div>
                    </div>
                    <div className={classes.input}>
                        <div className={classes.error}>
                            {formError.globalError}
                        </div>
                    </div>
                   
                    <Button1 onClick={(e)=>sendForm(e)} style={{marginTop:"15px"}}>
                        Войти
                    </Button1>

                    <div className={classes.linkAuth}>
                        Ещё нет аккаунта? <Link to='/reg'>Регистрация</Link>
                    </div>                  

                </form>
            </div>
            <FullSpaseLoader text='Отправка' isLoader={isSendFormLoader}/>
        </div>
     );
 }
  
 export default Auth;